<div layout="row">
    <ag-grid-angular #theGridTCO [frameworkComponents]="frameworkComponents" [style]="getGridStyle()"
    class="ag-theme-balham-main" [gridOptions]="gridOptions"
    [columnDefs]="columnDefs" [rowData]="gridData"></ag-grid-angular>
</div>
